<div class="modal-header">
    <h4 class="modal-title pull-left" translate>Unhandled comments</h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    <p translate>This ticket contains unhandled comments. Do you still want to close the ticket?</p>

    <div class="form-group flex-fill me-1 mw-50">
        <label class="checkbox__label checkbox__label--size-small">
            {{ 'Mark all comments as handled' | translate }}
            <input type="checkbox" [(ngModel)]="isMarkAsHandled" />
            <span class="checkbox__checkmark"></span>
        </label>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>No, I'll keep working on it</button>
    <button type="button" class="btn btn-primary" (click)="closeTicket()" translate>Yes, close the ticket</button>
</div>
